import React from "react";

const AbsentPresent = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    > <path
        fill="#60B158"
        d="M32.711 3.289H5.741A2.452 2.452 0 0 0 3.289 5.74v26.97L32.71 3.289Z"
        opacity={0.1}
    />
        <path
            fill="#60B158"
            d="M9.978 17.183v-7.49h3.326c.821 0 1.448.198 1.88.594.432.397.649.942.649 1.636 0 .688-.217 1.233-.649 1.637-.432.403-1.059.605-1.88.605h-1.955v3.018h-1.37Zm1.37-4.101h1.796c.454 0 .794-.1 1.02-.298.227-.205.34-.492.34-.86 0-.369-.113-.652-.34-.85-.226-.206-.566-.309-1.02-.309H11.35v2.317Z"
        />
        <path
            fill="#FF6961"
            d="M3.289 32.711h26.97a2.452 2.452 0 0 0 2.452-2.452V3.29L3.289 32.71Z"
            opacity={0.1}
        />
        <path
            fill="#FF6961"
            d="m19.737 27.807 3.389-7.49h1.147l3.432 7.49h-1.392l-.913-2.103.552.372h-4.494l.574-.372-.914 2.103h-1.381Zm3.952-6.024-1.498 3.549-.276-.33h3.57l-.223.33-1.53-3.549h-.043Z"
        />
        <path
            fill="#fff"
            fillRule="evenodd"
            d="M3.299 32.74a.395.395 0 0 1-.01-.569l28.863-28.9a.395.395 0 0 1 .56.558l-28.864 28.9a.395.395 0 0 1-.55.01Z"
            clipRule="evenodd"
        />
    </svg>
);

export default AbsentPresent;
